import React, { useMemo } from "react";
import { Tag, Button, Typography } from "design_system/src";
import useSkus from "hooks/useSkus";
import { SelectedSkuFilters } from "models/inventory/helpers/skuFilters.helpers";

interface Props {
  onChange: (changes: Partial<SelectedSkuFilters>) => void;
  onClearAll: () => void;
}

export const SkuFilterTagList: React.FC<Props> = ({ onChange, onClearAll }) => {
  const { selectedFilters } = useSkus();

  const filterList = useMemo(() => {
    if (!selectedFilters) return [];

    const { minPrice, maxPrice } = selectedFilters;

    const entries = Object.keys(selectedFilters)
      .filter((key) => key !== "sort" && key !== "minPrice" && key !== "maxPrice")
      .map((key) => ({ key: key as keyof SelectedSkuFilters, value: selectedFilters[key as keyof SelectedSkuFilters] }))
      .filter(({ value }) => value !== undefined)
      .map(({ key, value }) => ({
        key,
        value: key === "cc" ? `${value} CC` : `${value}`,
      }));

    if (minPrice !== undefined || maxPrice !== undefined) {
      let priceValue: string;
      if (minPrice !== undefined && maxPrice !== undefined) {
        priceValue = `$${minPrice} a $${maxPrice}`;
      } else if (minPrice !== undefined) {
        priceValue = `Más de $${minPrice}`;
      } else {
        priceValue = `Menos de $${maxPrice}`;
      }
      entries.push({ key: "minPrice", value: priceValue });
    }

    return entries;
  }, [selectedFilters]);

  return (
    <div className="display_flex flex_wrap flex_gap_xs">
      {filterList.map(({ key, value }, index) => (
        <Tag
          key={index}
          value={value}
          icon={null}
          className="bg-white"
          onDelete={() => onChange(key === "minPrice" ? { minPrice: undefined, maxPrice: undefined } : { [key]: undefined })}
        />
      ))}
      {filterList.length > 1 && <Button onClick={onClearAll} variant="link" scale="small">
        <Typography weight="400" className="text_secondary_600" scale="small">
          Borrar todos
        </Typography>
      </Button>}
    </div>
  );
};
